import React, { useState } from "react";
import ReactDataTable from "../../../components/Table/ReactDataTable";
import CardLayout from "../../../components/Layout/CardLayout";
import ModalLayout from "../../../components/Layout/ModalLayout";
import ServiceFormContainer from "./components/ServiceFormContainer";
import useFetch from "../../../hooks/useFetch";
import request from "../../../utils/request";
import toast from "react-hot-toast";
import { Button } from "react-bootstrap";

import { FaEdit } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";
import DeleteModal from "../../../components/DeleteModal/DeleteModal";

const ServiceList = () => {
  const [modalOpen, setModalOpen] = useState({ modalName: "", itemId: "" });

  const { data: serviceListData, setRefresh } = useFetch(() =>
    request.getAll("queue-management/service-list/all"),
  );

  const { data: counterListData } = useFetch(() =>
    request.getAll("queue-management/counter-list/"),
  );

  const modalCloseHandler = () => setModalOpen({ modalName: "", itemId: "" });

  const createServiceHandler = (val) =>
    request.create("queue-management/service-list", val, () => {
      toast.success("Service Added Successfully");
      setRefresh((prev) => !prev);
      modalCloseHandler();
    });

  const editServiceHandler = (val) =>
    request.updateOne(
      "queue-management/service-list",
      modalOpen.itemId,
      val,
      () => {
        setRefresh((prev) => !prev);

        modalCloseHandler();
      },
    );

  const deleteServiceHandler = (val) =>
    request.delete("queue-management/service-list", modalOpen.itemId, () => {
      setRefresh((prev) => !prev);
      modalCloseHandler();
    });

  const columns = [
    {
      name: "name",
      selector: (row) => row?.name,
      center: "true",
      wrap: true,
    },
    {
      name: "Counter",
      selector: (row) => row?.counter?.name,
      center: "true",
      wrap: true,
    },
    {
      name: "Prefix",
      selector: (row) => row?.prefix,
      center: "true",
      wrap: true,
    },
    {
      name: "Info",
      selector: (row) => row?.info,
      center: "true",
      wrap: true,
    },

    {
      name: "Active",
      selector: (row) => (row?.status ? "Yes" : "No"),
      center: "true",
      wrap: true,
    },
    {
      name: "Action",
      center: "true",
      wrap: true,
      cell: (row) => (
        <div>
          <Button
            onClick={() => setModalOpen({ modalName: "edit", itemId: row?.id })}
          >
            <FaEdit size={16} />
          </Button>
          <Button
            className="ms-2"
            variant="danger"
            onClick={() =>
              setModalOpen({ modalName: "delete", itemId: row?.id })
            }
          >
            <FaTrash size={16} />
          </Button>
        </div>
      ),
    },
  ];

  return (
    <CardLayout
      title="Service List"
      buttonTitle="Add Service"
      addButtonHandler={() => setModalOpen({ modalName: "add", itemId: "" })}
    >
      <ReactDataTable columns={columns} data={serviceListData} />

      {modalOpen.modalName === "add" && (
        <ModalLayout
          isOpen={modalOpen.modalName === "add"}
          onClose={modalCloseHandler}
          title={"Add New Service"}
        >
          <ServiceFormContainer
            counterListData={counterListData}
            apiHandler={createServiceHandler}
          />
        </ModalLayout>
      )}

      {/* edit modal  */}
      {modalOpen.modalName === "edit" && (
        <ModalLayout
          isOpen={modalOpen.modalName === "edit"}
          onClose={modalCloseHandler}
          title={"Edit Service"}
        >
          <ServiceFormContainer
            counterListData={counterListData}
            apiHandler={editServiceHandler}
            editData={serviceListData?.find(
              (item) => item?.id === modalOpen.itemId,
            )}
          />
        </ModalLayout>
      )}

      {/* delete modal  */}

      {modalOpen.modalName === "delete" && (
        <DeleteModal
          isOpen={modalOpen.modalName === "delete"}
          onClose={modalCloseHandler}
          handleDelete={deleteServiceHandler}
        />
      )}
    </CardLayout>
  );
};

export default ServiceList;
